import gsap from 'gsap'

const Hero = {
  el: {
    hero: document.querySelector<HTMLElement>('.hero-block'),
  },

  init() {
    const el = gsap.utils.selector(this.el.hero)

    gsap
      .timeline({
        defaults: {
          duration: 1,
          ease: 'none',
          scrollTrigger: {
            start: '0 0',
            end: '50% 0',
            trigger: document.body,
            scrub: 1,
          },
        },
      })
      .to(el('[data-id=back]'), { x: 55 }, 0)
      .to(el('[data-id=screen]'), { x: 5 }, 0)
      .to(el('[data-id=man]'), { x: -17 }, 0)
      .to(el('[data-id=woman]'), { x: -15 }, 0)
      .to(el('[data-id=man-and-woman]'), { x: 21 }, 0)

    gsap.to(el('[data-id=back]'), {
      scale: 1.1,
      transformOrigin: '50% 50%',
      duration: 2,
      ease: 'power3.out',
    })

    gsap
      .timeline({ defaults: { duration: 1.2, ease: 'power3.inOut' }, repeat: -1 })
      .set(el('[data-id*=window--1]'), { x: 0, y: 0 }, 0)
      .set(el('[data-id*=window--2]'), { x: 14, y: 46 }, 0)
      .set(el('[data-id*=window--3]'), { x: 27, y: 94, opacity: 0 }, 0)
      .to(el('[data-id*=window--1]'), { x: -96 }, 0.5)
      .to(el('[data-id*=window--1]'), { opacity: 0 }, 0.6)
      .to(el('[data-id*=window--2]'), { x: 0, y: 0 }, 0.65)
      .to(el('[data-id*=window--3]'), { x: 14, y: 46, opacity: 1 }, 0.7)

    gsap.set('.overlay-grid', { display: 'none' })
  },
}

export default Hero
